module.exports = __webpack_public_path__ + "img/we-are-hiring.27f828b1.png";